<div class="modal-header">
  <h5 class="modal-title" i18n>Add product or service</h5>
  <button type="button" class="btn-close" (click)="activeModal.close()"></button>
</div>

<div class="modal-body">
  <form [formGroup]="shiftForm">
    <div class="card mb-3" *ngFor="let product of products | localeSort: 'name'">
      <div class="card-header rounded d-flex align-items-center justify-content-between">
        <div class="d-flex align-items-center">
          <img #pictureTag [src]="product.picture" style="object-fit: cover; border-radius: 50%; height: 5rem; width: 5rem;" class="me-2 ms-0">
          <div>
            <div>{{ product | translateField: 'name' }}</div>
            {{ product | translateField: 'notes' }}
          </div>
        </div>
        <div class="d-inline-flex align-items-center user-select-none form-check form-switch"
          *ngIf="product.order_quantity_max == 1">
          <ng-container formArrayName="products">
            <input type="checkbox" class="form-check-input" [formControlName]="product.id"
              style="height: 1.5rem; width: 3rem; margin-right: 2rem;" (click)="setProductSingle(product, $event)">
          </ng-container>
        </div>
        <div class="d-inline-flex align-items-center user-select-none" *ngIf="product.order_quantity_max > 1">
          <ng-container formArrayName="products">
            <fa-icon [icon]="fa.faMinusCircle" class="d-inline m-1" style="font-size: 1.5rem;"
              (click)="setProduct(product, -product.order_quantity_step)"></fa-icon>
            <input (change)="setProductInput(product, $event)" (click)="selectContent($event)" type="number"
              [formControlName]="product.id" class="form-control d-inline" min="0" value="1"
              style="text-align: center; width: 3rem; padding-right: 0px; padding-left: 0px;">
            <fa-icon [icon]="fa.faPlusCircle" class="d-inline m-1" style="font-size: 1.5rem;"
              (click)="setProduct(product, product.order_quantity_step)"></fa-icon>
          </ng-container>
        </div>
      </div>
    </div>

    <h5>
      <span i18n>Price:</span>&nbsp;
      <ng-container *ngIf="!loading">{{ price | currency: organization.currency }}</ng-container>
      <ng-container *ngIf="loading"><div style="position: relative; top: -2px;" class="spinner-border spinner-border-sm" role="status"></div></ng-container>
    </h5>
    <p>
      <ng-container *ngIf="conflict">
        <span i18n>Worker is not available</span><br>
      </ng-container>
      <ng-container *ngIf="!conflict">
        <span i18n>New work end time:</span>&nbsp;{{ end | date: 'shortTime' }}<br>
      </ng-container>
    </p>
    <p >
      <span i18n>Pay with card:</span>&nbsp;
      <ng-container *ngIf="shift.customer_contact_card">
        {{ shift.customer_contact_card.number }}&nbsp;<span i18n>expires</span>&nbsp;{{ shift.customer_contact_card.expire_month | number: '2.0-0' }}/{{ shift.customer_contact_card.expire_year }}
      </ng-container>
      <span *ngIf="!shift.customer_contact_card" class="text-danger">No card associated with this order</span>
    </p>
    
  </form>
</div>
<div class="modal-footer text-end">
  <button type="button" class="btn btn-primary" [disabled]="conflict ||!this.shiftForm.valid" (click)="save()" i18n>Order</button>
  <button type="button" class="btn btn-secondary" (click)="activeModal.close()" i18n>Close</button>
</div>